export enum FilterType {
    lotteries = 'lotteries',
    systems = 'systems',
}

export enum TabComponent {
    None,
    NumberGenerator,
    StatisticsPicker,
    Favourites,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/enums.ts